import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Box, IconButton } from "@mui/material";
import Button from "@mui/material/Button";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers-pro-6";
import { AdapterDayjs } from "@mui/x-date-pickers-pro-6/AdapterDayjs";
import format from "date-fns/format";
import isExists from "date-fns/isExists";
import startOfDay from "date-fns/startOfDay";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { ExportButton } from "../../../../../../export/attendance-reports";
import ColumnSelector from "../../../../../../ts/design/column-selector";
import Searchbar from "../../../../../design/search-bar";
import { Filter } from "../../../../filters/filter-accordion/types";
import { setSelectedDayKPI } from "../../../store/worker-activity-slice";
import { ColumnSelector as ColumnSelectorComponent } from "../../../store/worker-activity-slice-types";

interface TableHeaderProps {
	date?: string;
	setDate?: (date: string) => void;
	search?: string;
	setSearch?: (search: string) => void;
	columnSelector?: ColumnSelectorComponent[];
	setColumnSelector?: (columnSelector: ColumnSelectorComponent[]) => void;
	exportData?: () => void;
	open?: boolean;
	setFilterOpen?: (open: boolean) => void;
}

const TableHeader = ({
	date,
	setDate,
	search,
	setSearch,
	columnSelector,
	setColumnSelector,
	exportData,
	open,
	setFilterOpen,
}: TableHeaderProps) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const handleSelectColumns = (checked: boolean, field: string) => {
		if (setColumnSelector && columnSelector) {
			setColumnSelector(
				columnSelector.map((column) =>
					column.field === field ? { ...column, checked } : column
				)
			);
		}
	};
	const changeDay = (value: "previous" | "next" | "today") => {
		dispatch(setSelectedDayKPI("ALL"));
		if (!setDate || !date) return;

		const dateMap = {
			previous: () => dayjs(date).subtract(1, "day"),
			next: () => dayjs(date).add(1, "day"),
			today: () => dayjs(),
		};

		setDate(dateMap[value]().toISOString());
	};

	const exportedData = exportData ? exportData() : [];
	return (
		<Box
			display='flex'
			justifyContent='space-between'
			alignItems='center'
			px={3}
		>
			<Box display='flex' alignItems='center'>
				<ColumnSelector
					columns={columnSelector}
					handleSelectColumns={handleSelectColumns}
					disabledColumns={["workerName"]}
				/>
				<Searchbar
					placeholder={" "}
					setSearch={(value) => setSearch?.(value)}
					value={search}
					variant={"filled"}
					width={"60ch"}
				/>

				<Box mx={1} my={2}>
					<Button
						color='primary'
						variant='outlined'
						onClick={() => changeDay("previous")}
					>
						<ArrowBackIcon />
					</Button>
				</Box>
				<Box mx={1} my={2}>
					<Button
						color='primary'
						variant='outlined'
						onClick={() => changeDay("next")}
					>
						<ArrowForwardIcon />
					</Button>
				</Box>
				<Box mx={1} my={2}>
					<Button
						color='primary'
						variant='outlined'
						onClick={() => changeDay("today")}
					>
						{t("worker-activity_today")}
					</Button>
				</Box>
				<Box mx={1} my={1}>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							value={dayjs(date)}
							onChange={(newValue) => {
								const date = newValue?.toISOString();
								if (date) {
									setDate?.(date);
								}
							}}
							slotProps={{
								//   field: { clearable: true },
								textField: {
									placeholder: t("worker-activity_select-date"),
									variant: "filled",
									size: "small",
									sx: {
										backgroundColor: "#f8f8f8",
										opacity: 0.8,
									},
								},
							}}
							sx={{
								height: "30px",
							}}
							format={"MM/DD/YYYY"}
							label={t("worker-activity_select-date")}
						/>
					</LocalizationProvider>
				</Box>
			</Box>

			<Box my={2}>
				<ExportButton data={exportedData} />
			</Box>
		</Box>
	);
};

export default TableHeader;
